import globalEventBus from 'toxilibs/event_bus_queued.js'
import style from './style.js'
import interpolate from 'toxilibs/interpolate.js'

let eventBus = globalEventBus('renderer')


let screen
let player
let cell
let winStartedAt = false
let shaking = false
let lastRenderedPosition
let lastRenderedPositionForTwin
let validAnimationDuration = 300

let toricDelta = false

let previousCellPosition = false
let movedAt    = false

let wallPosition
let collidedAt = false



eventBus.on('world loaded', function (world) {
    player = world.player
    if (screen) {
        screen.clear({layer: 1})
    }
})

eventBus.on('screen loaded', function (_screen) {
    screen = _screen
})

eventBus.on('player updated by God', reset)

eventBus.on('player reached checkPoint', reset) //FIXME

eventBus.on('new frame started', render)
eventBus.on('screen has been reset', render)

eventBus.on('player moved', move)
eventBus.on('player collided', collision)



eventBus.on('player has done bad', function () {
    shaking = true
})


eventBus.on('player has done well', function () {
    winStartedAt = Date.now()

    setTimeout(function () {
        eventBus.emit('player valid animation ended')
    }, validAnimationDuration)
})



function move (newCell, beforeToricCoords) {
    previousCellPosition = {
        x: cell.x,
        y: cell.y
    }


    if (beforeToricCoords) {
        handleToricMove(beforeToricCoords, newCell)
    } else {
        toricDelta = false
    }

    movedAt = Date.now()

    render(newCell)
}


function collision (_wallPosition) {
    collidedAt = Date.now()
    wallPosition = _wallPosition
}


function render (newCell) {

    if (newCell) {
        cell = newCell
    }

    if (!screen || !cell) {
        return
    }

    let position = {
        x: cell.x,
        y: cell.y
    }

    position = animateMovement(position)

    if (shaking) {
        position = movePlayerForShake(position)
    }

    let radius = computeRadius()

    if (toricDelta) {
        let twinPosition = {
            x: position.x - toricDelta.x,
            y: position.y - toricDelta.y
        }

        drawOnePlayer(twinPosition, radius, lastRenderedPositionForTwin)
        lastRenderedPositionForTwin = twinPosition
    } else {
        lastRenderedPositionForTwin = false
    }

    drawOnePlayer(position, radius, lastRenderedPosition)

    lastRenderedPosition = position
}



function reset (newCell) {
    previousCellPosition = false
    toricDelta           = false
    winStartedAt         = false
    shaking              = false
    render(newCell)
}


function handleToricMove (targetCoords, targetCell) {
    let {x, y} = targetCoords

    toricDelta = {
        x: targetCell.x - x,
        y: targetCell.y - y
    }

    previousCellPosition.x += toricDelta.x
    previousCellPosition.y += toricDelta.y
}



function drawOnePlayer (position, radius, clearPosition) {
    if (clearPosition) {
        clear(clearPosition)
    }

    if (winStartedAt) {
        drawAsValidSign(position, radius)
    } else {
        drawAsCircle(position, radius)
    }
}



function drawAsCircle (position, radius) {
    if (player && player.life < 100) {
        drawLife(position, radius, player.life)
    } else {
        screen.drawCircle({
            layer:     1,
            center:    position,
            radius,
            fillColor: style.colors.player
        })
    }
}


function drawLife (position, radius, life) {
    let angle = Math.acos((life / 50) - 1) * 180 / Math.PI

    screen.drawArc({
        layer:      1,
        center:     position,
        radius,
        fillColor:  style.colors.player,
        opacity:    0.5,
        startAngle: 90 - angle,
        endAngle:   90 + angle
    })

    if (life > 0) {
        screen.drawArc({
            layer:      1,
            center:     position,
            radius,
            fillColor:  style.colors.player,
            startAngle: 90 + angle,
            endAngle:   90 - angle
        })
    }
}


function drawAsValidSign ({x, y}, radius) {
    let ratio = Math.min(1, (Date.now() - winStartedAt) / validAnimationDuration)
    let curve = interpolate(
        curveForCircle(x, y, radius),
        curveForValidSign(x, y),
        ratio
    )
    curve.layer = 1
    curve.fillColor = style.colors.player
    screen.drawCurve(curve)
}



function curveForCircle (x, y, radius) {
    return {
        points: [
            {x: x + radius, y},
            {x,          y: y + radius},
            {x: x - radius, y},
            {x,          y: y - radius}
        ],
        close: true,
        smooth: 0.8
    }
}



function curveForValidSign (x, y) {
    x -= 0.05
    y -= 0.05
    return {
        points: [
            {x: x + 0.3, y: y + 0.3},
            {x,       y},
            {x: x - 0.2, y: y + 0.1},
            {x,          y: y - 0.2}
        ],
        close: true,
        smooth: 0.25
    }
}



function clear ({x, y}) {
    screen.clear({
        layer:  1,
        topLeft: {
            x: x - 0.5,
            y: y + 0.5
        },
        width:  1,
        height: 1
    })
}



function computeRadius () {
    let diffBetweenMinAndMax = style.playerMaxRadius - style.playerMinRadius
    let t = Math.sin(style.playerAnimationRadiusSpeed * Date.now() / 1000)
    let extraRadius = (1 + t / 2) * diffBetweenMinAndMax
    return style.playerMinRadius + extraRadius
}


function animateMovement (position) {
    if (!previousCellPosition) {
        return position
    }

    if (collidedAt && (!movedAt || collidedAt > movedAt)) {
        return animateCollision(position)
    } else {
        return animateClassicMovement(position)
    }

}


let classicMovementAnimationDuration = 200

function animateClassicMovement (position) {
    let ratio = Math.min(1, (Date.now() - movedAt) / classicMovementAnimationDuration)

    return interpolate({
        x: previousCellPosition.x,
        y: previousCellPosition.y
    }, position, ratio)
}



let collisionAnimationDuration = 200

function animateCollision (position) {
    let ratio = (Date.now() - collidedAt) / collisionAnimationDuration
    if (ratio > 0.5) {
        ratio = Math.max(0, 1 - ratio)
    }
    ratio *= 0.6

    return interpolate(position, wallPosition, ratio)

}



function movePlayerForShake ({x, y}) {
    return {
        x: x + Math.sin(style.playerShakeSpeed * Date.now() / 1000) * style.playerShakeIntensity,
        y
    }
}


